<template>
  <div class="">
    <div class="span fixed-top" v-if="$store.getters['Loading/loadingStatus']">
      <div id="loading-3" class="progress p-0 m-0">
        <div class="progress-bar" role="progressbar"
             :style="`width: ${percent($store.getters['Loading/requestCounter'])}%`" aria-valuenow="25"
             aria-valuemin="0"
             aria-valuemax="100"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading3",
  methods: {
    percent(value) {
      value = (100 / (value + 0.04))
      return value
    }
  },
}
</script>

<style>
#loading-3 .progress-bar {
  background: var(--secondary) !important;
}
</style>

<style scoped>
#loading-3 {
  background: #1f1e1e;
  height: 7px;
}
</style>
